import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';

const CheckboxInput = ({
  id,
  handleInputChange,
  metaTag,
  fileIndex,
  tagIndex,
  userInput,
}) => {
  //Effect to initialise checkbox with empty string when no user input
  useEffect(() => {
    if (!userInput) handleInputChange(fileIndex, tagIndex, '');
  }, []);

  const handleCheckboxChange = (value, isChecked) => {
    let updatedItems = userInput;
    if (isChecked) {
      updatedItems += updatedItems ? `,${value}` : value;
    } else {
      updatedItems = updatedItems
        .split(',')
        .filter((item) => item !== value)
        .join(',');
    }
    handleInputChange(fileIndex, tagIndex, updatedItems);
  };

  const isCheckboxChecked = (value) => {
    return userInput?.split(',').includes(value);
  };

  return (
    <Form.Check className="photo-uploader__image-list-form-check">
      {metaTag.list.map((checkboxElement, index) => (
        <div key={id + '_' + index}>
          <Form.Check.Label>
            <Form.Check.Input
              value={userInput}
              checked={isCheckboxChecked(checkboxElement)}
              id={metaTag.meta.id}
              onChange={(e) => {
                handleCheckboxChange(checkboxElement, e.target.checked);
              }}
              name="metaTag.meta.id"
            />{' '}
            {checkboxElement}
          </Form.Check.Label>
        </div>
      ))}
    </Form.Check>
  );
};

export default CheckboxInput;
